var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.01367,9.25A30.75,30.75,0,1,0,70.76367,40,30.78457,30.78457,0,0,0,40.01367,9.25Zm0,60A29.25,29.25,0,1,1,69.26367,40,29.28293,29.28293,0,0,1,40.01367,69.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.01367,21.25A10.8671,10.8671,0,0,0,29.15918,32.10547h1.5a9.355,9.355,0,1,1,18.71,0c0,3.79346-2.80176,5.85889-5.51074,7.85644-2.36328,1.74219-4.59473,3.38819-4.59473,6.03272l-.01367,2,1.5.01074L40.76367,46c0-1.89258,1.84668-3.25391,3.98535-4.83057,2.86817-2.11523,6.12012-4.51318,6.12012-9.064A10.86793,10.86793,0,0,0,40.01367,21.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.01367,53.25a2.75,2.75,0,1,0,2.75,2.75A2.7528,2.7528,0,0,0,40.01367,53.25Zm0,4a1.25,1.25,0,1,1,1.25-1.25A1.25116,1.25116,0,0,1,40.01367,57.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon_question.e9689b4ec0dedd2a9663126beff8f8ec.svg";
export { ForwardRef as ReactComponent };